(function () {
  if (theme?.settings?.cartType === 'page') return;

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    }));
  }

  // Intercept wk:add_to_cart (works if WK event is cancelable)
  document.addEventListener('wk:add_to_cart', async (event) => {
    event.preventDefault();

    const variantId = event.detail?.variant_id || event.detail?.variantId;
    const quantity = event.detail?.quantity || 1;
    if (!variantId) return;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (response.ok) openCartDrawer();
  });

  // Intercept form submits to /cart/add in capture phase (before WK's listener)
  // so WK never gets to do its own submit + redirect
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    if (!document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    });

    if (response.ok) openCartDrawer();
  }, true);

  // Intercept explicit location.assign('/cart') calls from WK
  const _assign = window.location.assign.bind(window.location);
  window.location.assign = function (url) {
    if (document.querySelector('cart-drawer') && (url === '/cart' || url.endsWith('/cart'))) {
      openCartDrawer();
      return;
    }
    _assign(url);
  };
})();
